import { render, staticRenderFns } from "./financialPlatformSold.vue?vue&type=template&id=39b1f766&"
import script from "./financialPlatformSold.vue?vue&type=script&lang=js&"
export * from "./financialPlatformSold.vue?vue&type=script&lang=js&"
import style0 from "./financialPlatformSold.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b1f766')) {
      api.createRecord('39b1f766', component.options)
    } else {
      api.reload('39b1f766', component.options)
    }
    module.hot.accept("./financialPlatformSold.vue?vue&type=template&id=39b1f766&", function () {
      api.rerender('39b1f766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/financialReport/financialPlatformSold.vue"
export default component.exports